import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { ButtonSize, ButtonType } from './button-interface';

@Component({
  selector: 'opac-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  private isOnlyIconButton = false;

  @HostBinding('class') get classAttribute() {
    return {
      'primary': this.type === 'primary',
      'secondary': this.type === 'secondary',
      'tertiary': this.type === 'tertiary',
      'text': this.type === 'text',
      'small': this.size === 'small',
      'only-icon': this.isOnlyIconButton,
    };
  }

  @ViewChild('onlyIcon', {static: true}) onlyIconEl!: ElementRef<HTMLElement>;

  /**
   * Determines html button type
   */
  @Input() actionType: 'button' | 'submit' | 'reset' = 'button';
  /**
   * Sets autofocus attribute in native input
   */
  @Input() autofocus: boolean = false;
  /**
   * Links with form id
   */
  @Input() form: string = '';
  /**
   * Determines aria label
   */
  @Input() ariaLabel: string = '';
  /**
   * Determines disabled status of button
   */
  @Input() disabled: boolean = false;
  /**
   * Determines button height size
   */
  @Input() size: ButtonSize = 'normal';
  /**
   * Determines if button should be focused
   */
  @Input() tabindex: number = 0;
  /**
   * Determines button styling
   */
  @Input() type: ButtonType = 'primary';

  ngOnInit() {
    this.isOnlyIconButton = this.onlyIconEl.nativeElement.children.length > 0;
  }
}
